<template>
  <ConfirmationModal
    confirmColor="danger"
    modalTestID="delete-rev-modal"
    :cancelTestID="cancelTestID"
    :confirmTestID="confirmTestID"
    :maxWidth="maxWidth"
    :show="show"
    :isLoading="isLoading"
    :title="titleText"
    :text="descriptionText"
    :confirmText="confirmDeleteText"
    :cancelText="cancelDeleteText"
    @cancel="$emit('cancel')"
    @confirm="$emit('delete')"
  />
</template>
<script>
import ConfirmationModal from './ConfirmationModal.vue'
export default {
  name: 'DeleteConfirmationModal',

  components: {
    ConfirmationModal,
  },

  props: {
    cancelTestID: {
      type: String,
      default: 'deleteConfirmation-button-cancel',
    },
    cancelText: String,
    confirmTestID: {
      type: String,
      default: 'deleteConfirmation-button-confirm',
    },
    confirmText: String,
    isLoading: Boolean,
    maxWidth: Number,
    show: Boolean,
    text: String,
    title: String,
  },

  computed: {
    titleText() {
      return this.title ?? this.$t('common.delete')
    },
    descriptionText() {
      return this.text ?? this.$t('common.this_action_cannot_be_undone')
    },
    confirmDeleteText() {
      return this.confirmText ?? this.$t('common.button.delete')
    },
    cancelDeleteText() {
      return this.cancelText ?? this.$t('common.button.cancel')
    },
  },
}
</script>
